import { render, staticRenderFns } from "./BaseAnnotation.vue?vue&type=template&id=356cb9c8&"
import script from "./BaseAnnotation.vue?vue&type=script&lang=js&"
export * from "./BaseAnnotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports